module.exports = __webpack_public_path__ + "static/media/already-logged-in.4ef9a091.svg";